import { Controller } from "@hotwired/stimulus"

// Polls for the country's largest-companies panel while the background Wikidata
// fetch runs. The Wikidata Query Service takes anywhere from 5s to a timeout, so
// the page renders without it and this fills the slot when it lands — the same
// brewing pattern the Lists app uses for research lists.
//
// The server returns rendered HTML rather than JSON rows so the formatting rules
// (dated figures, source links, the currency-filed-in note) live only in
// countries/_companies.html.slim.
export default class extends Controller {
    static targets = ["content"]
    static values = { url: String, ready: String }

    // Wikidata is slow, not instant-then-slow, so start a little back and ease
    // off rather than hammering the endpoint every second.
    static INTERVAL = 3000
    static MAX_ATTEMPTS = 12

    connect() {
        this.attempts = 0
        if (this.readyValue !== "true") this.schedule()
    }

    disconnect() {
        this.cancel()
    }

    schedule() {
        this.cancel()
        this.timer = setTimeout(() => this.poll(), this.constructor.INTERVAL)
    }

    cancel() {
        if (this.timer) clearTimeout(this.timer)
        this.timer = null
    }

    async poll() {
        this.attempts += 1

        try {
            const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
            if (!response.ok) return this.giveUpOrRetry()

            const payload = await response.json()
            if (payload.ready && payload.html) {
                this.contentTarget.innerHTML = payload.html
                return
            }
        } catch (error) {
            // Network hiccup — fall through to the retry decision.
        }

        this.giveUpOrRetry()
    }

    giveUpOrRetry() {
        if (this.attempts >= this.constructor.MAX_ATTEMPTS) {
            this.contentTarget.innerHTML =
                '<p class="countries-companies-empty">Wikidata didn\'t answer in time. Reload to try again.</p>'
            return
        }
        this.schedule()
    }
}
